module.exports = __webpack_public_path__ + "img/impressionen_clubhaus.09884d44.jpg";